import React, { useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";
import "./PasswordGate.css";

const CORRECT_CODE = "mustado"; // change as needed

export default function PasswordGate() {
    const [code, setCode] = useState("");
    const [status, setStatus] = useState("idle"); // idle | error | success | loading
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [accessForm, setAccessForm] = useState({
        fullName: "",
        company: "",
        email: "",
        phone: "",
    });
    const [accessFormStatus, setAccessFormStatus] = useState("idle"); // idle | success | error

    useEffect(() => {
        const granted = localStorage.getItem("stamp_access_granted");
        if (granted === "1") window.location.replace("/");
    }, []);

    const onSubmit = (e) => {
        e.preventDefault();
        setStatus("idle");
        if (code === CORRECT_CODE) {
            try {
                localStorage.setItem("stamp_access_granted", "1");
            } catch {}
            setStatus("success");
            setTimeout(() => window.location.replace("/"), 800);
        } else {
            setStatus("error");
        }
    };

    const onAccessRequest = (e) => {
        e.preventDefault();
        setShowAccessModal(true);
    };

    const closeAccessModal = () => {
        setShowAccessModal(false);
        setAccessFormStatus("idle");
        setAccessForm({
            fullName: "",
            company: "",
            email: "",
            phone: "",
        });
    };

    const handleAccessFormChange = (e) => {
        const { name, value } = e.target;
        setAccessForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAccessFormSubmit = async (e) => {
        e.preventDefault();
        setAccessFormStatus("loading");

        try {
            // Call the Firebase function
            const submitAccessRequest = httpsCallable(functions, "onAccessCodeRequest");
            const result = await submitAccessRequest(accessForm);

            console.log("Access request submitted successfully:", result.data);
            setAccessFormStatus("success");

            setTimeout(() => {
                closeAccessModal();
            }, 2000);
        } catch (error) {
            console.error("Error submitting access request:", error);
            setAccessFormStatus("error");
        }
    };

    return (
        <div
            className="pg-page"
            style={{ "--pg-bg-image": "url(/stamp-background.png)" }}>
            <div className="pg-container">
                <div className="pg-logo">
                    <img
                        src="/stamp-med-blue.png"
                        alt="Stamp Medical"
                    />
                </div>

                <div className="pg-card">
                    <h1>
                        JOIN THE <span className="pg-accent">FAMILY</span>
                    </h1>
                    <p className="pg-desc">Let us be the partner that grows with you. With our leadership, we provide premium personal injury treatment while adding a new stream of revenue for your practice.</p>

                    <form
                        onSubmit={onSubmit}
                        className="pg-form">
                        <label htmlFor="access">Access Code</label>
                        <input
                            id="access"
                            type="password"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="Enter your access code"
                            required
                            aria-invalid={status === "error"}
                        />
                        <button
                            type="submit"
                            className="pg-btn">
                            Access Network
                        </button>
                    </form>

                    {status === "error" && <div className="form-message error">Invalid access code. Please try again.</div>}
                    {status === "success" && <div className="form-message success">Access granted! Redirecting...</div>}

                    <div className="pg-footer-note">
                        <p className="pg-muted">Don't have an access code?</p>
                        <button
                            className="pg-link"
                            onClick={onAccessRequest}>
                            Contact us for exclusive access
                        </button>
                    </div>
                </div>
            </div>

            <div className="pg-footer">
                <div className="copyright">© 2025 Stamp Medical. All rights reserved.</div>
                <button className="pg-secure">🔒 Secure Access</button>
            </div>

            {/* Access Request Modal */}
            {showAccessModal && (
                <div
                    className="pg-modal-overlay"
                    onClick={closeAccessModal}>
                    <div
                        className="pg-modal-content"
                        onClick={(e) => e.stopPropagation()}>
                        <div className="pg-modal-header">
                            <h3>Get Exclusive Access</h3>
                            <button
                                className="pg-modal-close"
                                onClick={closeAccessModal}>
                                ×
                            </button>
                        </div>
                        <div className="pg-modal-body">
                            {accessFormStatus === "success" ? (
                                <div className="form-message success">✅ Thank you for your request! We'll get back to you soon with your access code.</div>
                            ) : (
                                <form
                                    onSubmit={handleAccessFormSubmit}
                                    className="pg-access-form">
                                    <div className="pg-form-group">
                                        <label htmlFor="fullName">Full Name *</label>
                                        <input
                                            type="text"
                                            id="fullName"
                                            name="fullName"
                                            value={accessForm.fullName}
                                            onChange={handleAccessFormChange}
                                            required
                                            placeholder="Enter your full name"
                                        />
                                    </div>
                                    <div className="pg-form-group">
                                        <label htmlFor="company">Company *</label>
                                        <input
                                            type="text"
                                            id="company"
                                            name="company"
                                            value={accessForm.company}
                                            onChange={handleAccessFormChange}
                                            required
                                            placeholder="Enter your company name"
                                        />
                                    </div>
                                    <div className="pg-form-group">
                                        <label htmlFor="email">Email *</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={accessForm.email}
                                            onChange={handleAccessFormChange}
                                            required
                                            placeholder="Enter your email address"
                                        />
                                    </div>
                                    <div className="pg-form-group">
                                        <label htmlFor="phone">Phone *</label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            value={accessForm.phone}
                                            onChange={handleAccessFormChange}
                                            required
                                            placeholder="Enter your phone number"
                                        />
                                    </div>
                                    {accessFormStatus === "error" && (
                                        <div className="pg-access-error">
                                            <p>❌ Something went wrong. Please try again.</p>
                                        </div>
                                    )}
                                    <div className="pg-modal-actions">
                                        <button
                                            type="button"
                                            className="pg-btn-secondary"
                                            onClick={closeAccessModal}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="pg-btn-primary"
                                            disabled={accessFormStatus === "loading"}>
                                            {accessFormStatus === "loading" ? "Submitting..." : "Request Access"}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
